module.exports = __webpack_public_path__ + "static/media/bigwaster-logo.c161c959.png";